import { render, staticRenderFns } from "./p-add-package-popup.vue?vue&type=template&id=f1909350&scoped=true"
import script from "./p-add-package-popup.vue?vue&type=script&lang=js"
export * from "./p-add-package-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1909350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1909350')) {
      api.createRecord('f1909350', component.options)
    } else {
      api.reload('f1909350', component.options)
    }
    module.hot.accept("./p-add-package-popup.vue?vue&type=template&id=f1909350&scoped=true", function () {
      api.rerender('f1909350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-add-package-popup/p-add-package-popup.vue"
export default component.exports